import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    ViewChild,
} from "@angular/core";
import {
    AsyncModalButton,
    AsyncModalService,
} from "../../services/shared/async-modal-service";

@Component({
    standalone: false,
    selector: "app-async-modal",
    templateUrl: "./async-modal.component.html",
})
export class AsyncModalComponent {
    asyncModalService: AsyncModalService;
    @ViewChild("openModal") private openModalButton: ElementRef;
    @ViewChild("closeModal") private closeModalButton: ElementRef;

    private changeDetectorRef: ChangeDetectorRef;

    constructor(
        asyncModalService: AsyncModalService,
        changeDetectorRef: ChangeDetectorRef
    ) {
        this.asyncModalService = asyncModalService;
        this.changeDetectorRef = changeDetectorRef;
    }

    ngOnInit() {
        this.asyncModalService.showModal = () => this.show();
        this.asyncModalService.closeModal = () => this.close();
    }

    show() {
        this.openModalButton?.nativeElement?.click();

        if (!this.changeDetectorRef["destroyed"])
            this.changeDetectorRef.detectChanges();
    }

    close() {
        this.closeModalButton?.nativeElement?.click();
    }

    hide(button: AsyncModalButton) {
        var value = button.label;

        if (button.value || button.value === false) value = button.value;

        if (typeof button.value == "function") {
            button.value(button);
        }

        if (button.closeOnClick !== false) this.asyncModalService.hide(value);
    }
}
